/* eslint-disable no-param-reassign */
import { config } from 'src/constants';
import {
  // file
  FILE_NAMESPACE,

  // plate size details fields
  SCALE_FIELD,
  SYNTHESIS_SCALE_OPTIONS,

  // namespaces
  PLATE_SIZE_FIELD,
  PLATE_SIZE_DETAILS_NAMESPACE,
  PLATE_POOLING_NAMESPACE,
  PLATE_POOLING,
  NORMALIZATION_CONCENTRATION,
  NORMALIZATION_VOLUME,
} from 'src/constants/forms';
import { cartRequestMockHeaders } from 'src/mocks';

export default class Email {
  static NAME = 'Email';

  static MAX_LENGTH = 5;

  static ERROR = 'error';

  static DEFAULT_PAYLOAD_STRING = '';

  static DEFAULT_EMAIL_STATE = {
    value: '',
    isValid: false
  };

  static getCreateConfig() {
    return {
      url: '/v2/oligos/plates/sendEmail',
      ...(config.isDevEnv ? { headers: cartRequestMockHeaders } : {}),
    };
  }

  static emailPayloadData = (collectedData, payload = {}) => {
    const payloadData = {};

    const fileData = collectedData[FILE_NAMESPACE] || {};
    const plateSizeData = collectedData[PLATE_SIZE_DETAILS_NAMESPACE] || {};
    const platePoolingData = collectedData[PLATE_POOLING_NAMESPACE] || {};

    if (fileData?.data) {
      payloadData.totalPlatesNo = fileData.data?.platesCount;
      payloadData.totalOligosNo = fileData.data?.oligosCount;
      payloadData.totalBases = fileData.data?.basesCount;
    }

    payloadData.plateSize = plateSizeData[PLATE_SIZE_FIELD]?.value;

    const synthesisScale = plateSizeData[SCALE_FIELD]?.value;

    if (synthesisScale) {
      payloadData.synthesisScale = SYNTHESIS_SCALE_OPTIONS.find(
        (item) => item.value === synthesisScale
      )?.label;
    }

    if (payload[NORMALIZATION_VOLUME]) {
      payloadData.volume = payload[NORMALIZATION_VOLUME];
      delete payload[NORMALIZATION_VOLUME];
    }

    if (payload[NORMALIZATION_CONCENTRATION]) {
      payloadData.concentration = payload[NORMALIZATION_CONCENTRATION];
      delete payload[NORMALIZATION_CONCENTRATION];
    }

    if (payload.volumeNormalizationUom) {
      payloadData.volumeUnit = payload.volumeNormalizationUom;
      delete payload.volumeNormalizationUom;
    }

    if (payload.concentrationNormalizationUom) {
      payloadData.concentrationUnit = payload.concentrationNormalizationUom;
      delete payload.concentrationNormalizationUom;
    }

    if (payload?.poolList) {
      delete payload.poolList;
    }

    payloadData.platePoolingType = platePoolingData[PLATE_POOLING]?.value;

    return { ...payload, ...payloadData };
  };
}
